
import { supabase } from "@/integrations/supabase/client";
import { getCampaignCookie, removeCampaignCookie } from "@/hooks/referrals/referralUtils";

export const createCampaignTrial = async (userId: string) => {
  try {
    // Check if we have a campaign cookie
    const campaignValue = getCampaignCookie();
    
    if (!campaignValue) {
      console.log("No campaign cookie found, skipping trial creation");
      return false;
    }
    
    console.log(`Found campaign cookie: ${campaignValue}, creating trial subscription`);

    const { data: { session } } = await supabase.auth.getSession();
    const authHeader = session
        ? { Authorization: `Bearer ${session.access_token}` }
        : undefined;
    
    // Call the apply-referral-month function with campaign parameters
    const { data, error } = await supabase.functions.invoke('apply-referral-month', {
      body: {
        userId: userId,
        trialMonths: 3, // 3-month trial for campaign signups
        campaignValue: campaignValue
      },
      // Include auth header if we have a session
      headers: authHeader
    });

    removeCampaignCookie();
    
    if (error) {
      removeCampaignCookie();
      console.error("Error creating campaign trial subscription:", error);
      return false;
    }
    
    if (data?.success) {
      console.log("Successfully created campaign trial subscription:", data);
      return true;
    } else {
      console.warn("Campaign subscription creation failed:", data?.error || "Unknown error");
      return false;
    }


  } catch (error) {
    console.error("Exception during campaign trial creation:", error);
    return false;
  }
};
